import React from 'react';
import ContainerFileManager from '../../Componant/FileManager';

const FileManager = () => {
  return (
    <div className='page-body'>
      <ContainerFileManager />
    </div>
  );
};

export default FileManager;
